import { render, staticRenderFns } from "./SINGLETEXT.vue?vue&type=template&id=3a865822&scoped=true&lang=pug"
import script from "./SINGLETEXT.vue?vue&type=script&lang=js"
export * from "./SINGLETEXT.vue?vue&type=script&lang=js"
import style0 from "./SINGLETEXT.vue?vue&type=style&index=0&id=3a865822&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a865822",
  null
  
)

export default component.exports